<template>
  <div class="customer-payment body">
    <el-container>
      <!-- <CustomersAside /> -->
      <el-main>
        <div class="bg-White p-3 mt-2">
          <el-row :gutter="10">
            <el-col :xl="10" :lg="10" :md="6" :sm="12">
              <el-input
                v-model="customerName"
                @keyup.native="filterCustomer"
                placeholder="بحـث باسـم العـمـيـل"
              />
            </el-col>
            <el-col :pull="12" :lg="2">
              <el-button
                type="success"
                title="طباعه"
                icon="el-icon-printer"
                @click="sendToPrint()"
              ></el-button>
            </el-col>
          </el-row>
        </div>
        <el-table :data="tableData" border>
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column
            label="الاسم"
            prop="name"
            width="220px"
          ></el-table-column>
          <el-table-column
            label="الهاتف"
            prop="phone"
            width="150px"
          ></el-table-column>
          <el-table-column label="العنوان" prop="address"></el-table-column>
          <el-table-column label="الحساب" width="150px">
            <template slot-scope="scope">
              <span>{{
                numberToFixed(
                  Number(scope.row.balance) + Number(scope.row.account)
                )
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="نوع التسعير" width="130px">
            <template slot-scope="scope">
              <span v-if="scope.row.price_type == 1">جملة الجملة</span>
              <span v-if="scope.row.price_type == 2">جملة</span>
            </template>
          </el-table-column>
          <el-table-column label="اجراء" width="110px">
            <template slot-scope="scope">
              <el-row :gutter="10">
                <el-col :lg="12" v-if="accessLinks('update_customer')">
                  <el-button
                    size="mini"
                    type="warning"
                    title="تعديل"
                    icon="el-icon-edit"
                    @click="editCustomer(scope.row)"
                  >
                  </el-button>
                </el-col>
                <el-col :lg="12" v-if="accessLinks('delete_customer')">
                  <el-popconfirm
                    confirm-button-text="موافق"
                    cancel-button-text="إلغاء"
                    icon="el-icon-info"
                    icon-color="red"
                    :title="'هل تريد حذف ' + ' ' + scope.row.name + ' ؟'"
                    @confirm="deleteCustomer(scope.row.id)"
                  >
                    <div slot="reference">
                      <el-button
                        title="حذف"
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                      ></el-button>
                    </div>
                  </el-popconfirm>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          :fullscreen="false"
          title="تعديل بيانات العميل"
          :visible.sync="editFormVisible"
          v-if="selectedCustomers"
        >
          <el-form
            :rules="rules"
            ref="NewCustomer"
            :model="selectedCustomers"
            label-width="120px"
            label-position="top"
          >
            <el-row :gutter="10">
              <el-col :xl="6" :lg="6" :md="12" :sm="12">
                <el-form-item label="نوع الحساب" prop="type">
                  <el-select
                    id="input1"
                    class="input1"
                    v-model="selectedCustomers.type"
                    placeholder=" نوع الحساب"
                    style="width: 100%"
                  >
                    <el-option label="عميل" :value="1"> </el-option>
                    <el-option label=" عميل و مورد" :value="2"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <el-form-item label="نوع التسعير" prop="price_type">
                  <el-select
                    id="input2"
                    class="input2"
                    v-model="selectedCustomers.price_type"
                    placeholder="نوع التسعير"
                    style="width: 100%"
                  >
                    <el-option label="جملة" :value="2"> </el-option>
                    <el-option label="جملة الجملة" :value="1"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="10" :lg="10" :md="24" :sm="24">
                <el-form-item label="الاسم" prop="name">
                  <el-input
                    class="input3"
                    @focus="$event.target.select()"
                    v-model="selectedCustomers.name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <el-form-item label="رصيد العميل" prop="account">
                  <el-input
                    class="input4"
                    id="account"
                    type="number"
                    @focus="$event.target.select()"
                    v-model="selectedCustomers.account"
                    controls-position="right"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :xl="4" :lg="4" :md="12" :sm="12" v-if="form.type == 2">
                <el-form-item label="رصيد المورد" prop="supplier_account">
                  <el-input
                    :class="form.type == 2 ? 'input5' : ''"
                    id="supplier_account"
                    @focus="$event.target.select()"
                    v-model="form.supplier_account"
                    @keyup.enter.native="focusNext"
                  ></el-input>
                </el-form-item>
              </el-col> -->
            </el-row>
            <el-row :gutter="10">
              <el-col :xl="6" :lg="6" :md="12" :sm="12">
                <el-form-item label="رقم الهاتف" prop="phone">
                  <el-input
                    class="input4"
                    id="phone"
                    @focus="$event.target.select()"
                    v-model="selectedCustomers.phone"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="العنوان" prop="address">
                  <el-input
                    class="input5"
                    id="address"
                    @focus="$event.target.select()"
                    v-model="selectedCustomers.address"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="update">حفظ التعديلات</el-button>
            <el-button class="mr-3" @click="editFormVisible = false"
              >إلغاء</el-button
            >
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// import CustomersAside from "@/components/CustomersAside.vue";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";
export default {
  // components: { CustomersAside },
  data() {
    return {
      tableData: [],
      editFormVisible: false,
      selectedCustomers: {},
      rules: {
        type: [
          { required: true, message: "حدد نوع حساب العميل", trigger: "blur" },
        ],
        name: [{ required: true, message: "حدد اسم العميل", trigger: "blur" }],
        account: [
          { required: true, message: "حدد الرصيد الافتتاحي", trigger: "blur" },
        ],
        price_type: [
          { required: true, message: "حدد سياسة التسعير ", trigger: "blur" },
        ],
        address: [{ required: true, message: "حدد العنوان ", trigger: "blur" }],
        phone: [
          { required: true, message: "حدد رقم الهاتف", trigger: "blur" },
          { min: 11, max: 11, message: "حدد رقم هاتف صحيح", trigger: "change" },
        ],
      },
      customerName: "",
    };
  },
  methods: {
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    getAllCustomer() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .get("customers")
        .then((res) => {
          this.tableData = res.data;
          localStorage.setItem("customerReportAll", JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    editCustomer(row) {
      this.selectedCustomers = {};
      this.selectedCustomers = row;
      this.editFormVisible = true;
    },
    update() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .put(`customers/${this.selectedCustomers.id}`, this.selectedCustomers)
        .then((res) => {
          this.editFormVisible = false;
          this.selectedCustomers = {};
          this.tableData = res.data;
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات العميل بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch(() => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "عفوا تأكد من بيانات المطلوبة",
            duration: 1500,
          });
        })
        .finally(() => {
          loading.close();
        });
    },
    deleteCustomer(id) {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .delete(`customers/${id}`)
        .then((res) => {
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حذف بيانات العميل بنجاح",
            type: "success",
            duration: 1500,
          });
          this.getAllCustomer();
          console.log(res);
        })
        .catch(() => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "عفوا تأكد من بيانات المطلوبة",
            duration: 1500,
          });
        })
        .finally(() => {
          loading.close();
        });
    },
    filterCustomer() {
      let Data = [];
      let ReportAll = JSON.parse(localStorage.getItem("customerReportAll"));
      if (this.customerName !== "") {
        for (let i = 0; i < ReportAll.length; i++) {
          if (ReportAll[i].name.match(this.customerName)) {
            Data.push(ReportAll[i]);
          }
        }
      } else {
        Data = ReportAll;
      }
      this.tableData = Data;
    },
    sendToPrint() {
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: this.tableData,
      //   type: "CustomersReportAll",
      //   customer: { customerName: this.customerName, isCustomer: true },
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
  mounted() {
    this.getAllCustomer();
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 89%;
  overflow-y: scroll;
}
</style>
